import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import { useHistory } from "react-router-dom";
import Grid from "@material-ui/core/Grid";
import Button from "@material-ui/core/Button";
import IconButton from "@material-ui/core/IconButton";
import CloseIcon from "@material-ui/icons/Close";
import MaterialTable from "material-table";
import {
  MuiThemeProvider,
  createMuiTheme,
  makeStyles,
  createStyles,
} from "@material-ui/core/styles";
import InputLabel from "@material-ui/core/InputLabel";
import MenuItem from "@material-ui/core/MenuItem";
import FormControl from "@material-ui/core/FormControl";
import Select from "@material-ui/core/Select";

import { KeyboardDatePicker } from "@material-ui/pickers";
import { MuiPickersUtilsProvider } from "@material-ui/pickers";
import DateFnsUtils from "@date-io/date-fns";
import format from "date-fns/format";

import { initializeApp, getApps, getApp } from "firebase/app";
import {
  getFirestore,
  collection,
  doc,
  query,
  where,
  orderBy,
  startAfter,
  limit,
  getDoc,
  getDocs,
  onSnapshot,
} from "firebase/firestore";

import { devicePhaseCode, deviceModeCode, serviceType } from "../../constants/constants";

import { db, getCheckSession, logout } from "../../apis/auth";
import DeviceAddressService from "../../apis/device-address";
import DeviceDataService from "../../apis/device-data"
import {GetDailyReport} from "./ReportManager" 
import "../../styles/reports.scss";
import { exportMaterialTableToExcel, exportMaterialTableToPDF, format2Decimals, getDateString, getDateStringHHMMSS } from "../../utilities/utility";
import { ExportCsv, ExportPdf } from "@material-table/exporters";
import { GetEventReportQuery } from "../../query/event-report.query";
import { Backdrop, CircularProgress } from "@material-ui/core";
import { NotificationManager } from "react-notifications";

const useStyles = makeStyles((theme) =>
  createStyles({
    button: {
      margin: theme.spacing(1),
    },
    table: {
      minWidth: 650,
    },
    root: {
      width: "100%",
    },
    instructions: {
      marginTop: theme.spacing(1),
      marginBottom: theme.spacing(1),
    },
    formControl: {
      margin: theme.spacing(1),
      minWidth: 120,
      marginRight: 20,
    },
    selectEmpty: {
      marginTop: theme.spacing(2),
    },
  })
);

const EventReport = (props) => {
  
  const classes = useStyles();
  const history = useHistory();

  const [isAPILoading, setIsAPILoading] = useState(false);
  const [filterObj, setFilterObj] = useState({
    zone: 0,
    ward: 0,
    ccms: 0,
    filterType:0,
    startDate: new Date(),
    endDate: new Date(),
  });
  
  const [filterTypeList, setFilterTypeList] = useState([
    {
      label: "UID",
      value: 0,
    },
    {
      label: "Switch No",
      value: 1,
    }
  ]);
  const [zoneFilterList, setZoneFilterList] = useState([]);
  const [wardFilterList, setWardFilterList] = useState([]);
  const [ccmsFilterList, setCcmsFilterList] = useState([]);

  //   const [dashboardReportData, setDashboardReportData] = useState([]);
  const [dashboardReportRawData, setDashboardReportRawData] = useState([]); //TODO: can be removed
  const [opReportData, setOpReportData] = useState([]);

  useEffect( async() => {
    console.log("========== Report : OnInit() ==========");
    var sessionStatus = await getCheckSession();
    if (sessionStatus === false) {
      history.push("/");
      return;
    }

    await DeviceAddressService.getInstance().getAllAddressAPICall();
    let zoneList = DeviceAddressService.getInstance().getZones(false);
    let wardList = [];//DeviceAddressService.getInstance().getWards(zoneList[0].value);
    setZoneFilterList(zoneList);
    setWardFilterList(wardList);
    console.log(`==> Zone list ${zoneList}\n\n WardList = ${wardList}`);
    // setFilterObj((prevState) => ({
    //   ...prevState,
    //   zone: zoneList[0].value,
    //   ward: wardList[0].value,
    // }));

    // setTimeout(() => {
      // getAllDevicesAPICall();
      //   getAllDeviceSummaryAPICall();
      // const treeZoneList = getZones();
      // const zoneList = treeZoneList.map((item) => ({
      //   label: item.value,
      //   value: item.id,
      //   // id: item.id
      // }));
      // console.log("getZones : ", zoneList);
      // setZoneFilterList(zoneList || []);
    // }, 3000);
    
    DeviceDataService.getInstance().initService(onFetchComplete,()=> {
      
    }/*iterateDeviceHandler*/);
  }, []);

  async function onFetchComplete() {
    console.log(`========= EventReport : onFetchall SLC Device Complete()`);
  }

  async function updateDeviceFilterList(zoneId = 0, wardId = 0) {
    const {deviceList:deviceList = [] } = await DeviceDataService.getInstance().getDevicesByFilter(zoneId, wardId);
    setCcmsFilterList(deviceList);
  }

  const getOpReportColumnList = () => {
    return [
      {
        title: 'DATE',
        field: "displayData_date",
        type: "datetime",
        exportTransformer:({displayData_date: displayData_date = 'N/A'}) => {
          return displayData_date.toLocaleString();
        },
      },
      {
        title: 'EVENT TYPE',
        field: "displayData_eventType",
        sorting: false,
        // type: "numeric",
        // render:({displayData_eventType: displayData_eventType = 0}) => {
        //   return displayData_eventType;
        // },
        exportTransformer:({displayData_eventType: displayData_eventType = 0}) => {
          return displayData_eventType;
        },
      },
      {
        title: 'DATA',
        field: "displayData_status",
        sorting: false,
        width: "80%",
        // render:({displayData_status:displayData_status = ""}) => {
        //   return displayData_status;
        // },
        exportTransformer:({displayData_status:displayData_status = ""}) => {
          return displayData_status;
        },
      }
    ];
  };

  const handleDateChange = (date, dateField) => {
    setFilterObj((prevState) => ({
      ...prevState,
      [dateField]: date,
    }));
  };

  const handleFilterChange = async(e) => {
    const { target: { name = "", value = "" } = {} } = e;
    console.log(`handleFilterChange -> ${name} = ${value}`);
    if (name === "zone") {
      let wardList = DeviceAddressService.getInstance().getWards(value, false);
      setWardFilterList(wardList);
      setFilterObj((prevState) => ({
        ...prevState,
        zone: value,
        ward: 0,
        ccms: 0,
      }));
    }else if (name === "ward") {
      const { zone: zone = 0} = filterObj;
      await updateDeviceFilterList(zone, value);
      setFilterObj((prevState) => ({
        ...prevState,
        ward: value,
        ccms:0,
      }));
    }else if (name === "filter-type") {
      setFilterObj((prevState) => ({
        ...prevState,
        filterType: value,
        ccms:0,
      }));
    }else if (name === "ccms") {
      setFilterObj((prevState) => ({
        ...prevState,
        ccms: value,
      }));
    }
  };

  const handleFilterApply = async() => {
    const {
      startDate = new Date(),
      endDate = new Date(),
      filterType = 0,
      zone = 0,
      ward = 0,
      ccms = 0,
    } = filterObj;
    startDate.setHours(0,0,0,0);
    endDate.setHours(23,59,59,0);
    if (startDate > endDate) {
      NotificationManager.error("Please select valid date", "", 3000);
      return;
    }
    const diffTime = Math.abs(endDate - startDate);
    const diffDays = Math.ceil(diffTime / (1000 * 60 * 60 * 24));
    if (diffDays > 31) {
      NotificationManager.error("Please select date range less than or equal to 31 days", "", 5000);
      return;
    }
    if (zone == 0) {
      NotificationManager.error("Please select valid zone", "", 3000);
      return;
    }  
    if (ward == 0) {
      NotificationManager.error("Please select valid ward", "", 3000);
      return;
    }
    if (ccms == 0) {
      if (filterType == 0) {
        NotificationManager.error("Please select valid UID", "", 3000);
      } else {
        NotificationManager.error("Please select valid switch number", "", 3000);
      }
      return;
    }
    setIsAPILoading(true);
    GetEventReportQuery(startDate,endDate,ccms).then((reportList) => {
      setOpReportData([...reportList]);
      setIsAPILoading(false);
    }).catch((error) => {
      console.log('Energy Saving Report==> ', error.message);
      alert("Unable to complete your request. Please try after sometime.");
    });
    // getAllDeviceSummaryAPICall();
  };

  const {
    startDate = new Date(),
    endDate = new Date(),
    filterType: filterType = 0,
    zone: zoneFilter = 0,
    ward: wardFilter = 0,
    ccms: ccmsFilter = 0,
  } = filterObj;

  return (
    <div className="reports">
      {/* {isAPILoading && (
        <Backdrop open={true} className={classes.backdrop}>
          <CircularProgress
            className="circular-progress-center"
            disableShrink
          />
        </Backdrop>
      )} */}
      <h2 className="reports-header">Event Report</h2>
      <Grid container className="reports-filter-wrapper">
        <Grid xs={12} sm={12}>
          <div className="reports-zw-filter">
          <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              {/* Start Date */}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="Start Date"
              value={startDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "startDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
          </FormControl>
          <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
          {/* End Date */}
          <MuiPickersUtilsProvider utils={DateFnsUtils}>
            <KeyboardDatePicker
              clearable
              autoOk
              label="End Date"
              value={endDate}
              placeholder="dd/MM/yyyy"
              InputAdornmentProps={{ position: "end" }}
              onChange={(date) => handleDateChange(date, "endDate")}
              variant="inline"
              inputVariant="outlined"
              // minDate={new Date()}
              format="dd/MM/yyyy"
            />
          </MuiPickersUtilsProvider>
          </FormControl>
          {/* Zone */}
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="zone-label">Zone</InputLabel>
              <Select
                labelId="zone-label"
                id="zone-outlined"
                name="zone"
                value={zoneFilter}
                onChange={handleFilterChange}
                label="Zone"
              >
                {zoneFilterList.map((item) => (
                  <MenuItem key={item.value} value={item.value}>
                    {item.label}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Ward */}
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="ward-label">Ward</InputLabel>
              <Select
                labelId="ward-label"
                id="ward-outlined"
                name="ward"
                value={wardFilter}
                onChange={handleFilterChange}
                label="Ward"
              >
                {wardFilterList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* Filter Type */}
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="filter-type-label">Type</InputLabel>
              <Select
                labelId="filter-type-label"
                id="filter-type-outlined"
                name="filter-type"
                value={filterType}
                onChange={handleFilterChange}
                label="Type"
              >
                {filterTypeList.map((item) => (
                  <MenuItem value={item.value}>{item.label}</MenuItem>
                ))}
              </Select>
            </FormControl>
            {/* UID */}
            <FormControl
              variant="outlined"
              className={`${classes.formControl} filter-wrapper`}
            >
              <InputLabel id="ccms-label">{filterType == 0 ? "UID":"Switch No"}</InputLabel>
              <Select
                labelId="ccms-label"
                id="ccms-outlined"
                name="ccms"
                value={ccmsFilter}
                onChange={handleFilterChange}
                label="UID"
              >
                { filterType == 0 ? 
                ccmsFilterList.map((item) => (
                  <MenuItem key={item.docId} value={item.docId}>
                    {item.dev_id}
                  </MenuItem>
                ))
                :
                ccmsFilterList.map((item) => (
                  <MenuItem key={item.docId} value={item.docId}>
                    {item.sw_no}
                  </MenuItem>
                ))}
              </Select>
            </FormControl>
            <Button
              variant="contained"
              className="ml-auto reports-apply-btn"
              onClick={handleFilterApply}
            >
              Apply
            </Button>
          </div>
        </Grid>
      </Grid>

      <div className="dashboard-table">
        <MaterialTable
          style={{
            margin: "20px 0",
            width: "100%",
          }}
          className={classes.table}
          title=""
          columns={getOpReportColumnList()}
          data={opReportData}
          onRowClick={(evt, rowData) => {
            console.log("row click", evt, rowData);
            // setSelectedRowData(rowData);
            // setIsErrorDialogOpen(true);
          }}
          options={{
            exportButton: true,
              exportAllData:true,
              exportCsv:(columns, csvData) => {exportMaterialTableToExcel(columns, csvData, `Energy Saving Report-${getDateString()}`);},
              exportPdf:(columns, csvData) => {exportMaterialTableToPDF(columns, csvData, `Energy Saving Report-${getDateString()}`, 8, 18);},
              // exportCsv: (columns, data) => ExportCsv(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`,","),
              // exportPdf: (columns, data) => ExportPdf(columns.filter(item=> item.export === undefined || item.export === true), data, `Energy Saving Report-${getDateString(filterObj.startDate)}`),
            // grouping: true,
            search: true,
            selection: false,
            sorting: true,
            pageSize: 10,
            // rowStyle: (rowData) => ({
            //   backgroundColor:
            //     rowData?.ccmsNumber === selectedRowData?.ccmsNumber
            //       ? "#f0f2f4"
            //       : "",
            // }),
            headerStyle: {
              backgroundColor: "#0071CE",
              color: "#FFF",
              fontSize: "0.9em",
              textAlign: "center",
            },
            actionsColumnIndex: -1,
            emptyRowsWhenPaging: false,
          }}
          localization={{
            toolbar: {
              searchPlaceholder: "Search",
              exportCSVName: "Export as Excel",
              exportPDFName: "Export as PDF",
            },
          }}
        />
      </div>
    </div>
  );
};
export default EventReport;
